import { render } from "./Involvement.html?vue&type=template&id=f20ddb66&scoped=true&ts=true&external"
import script from "./Involvement.ts?vue&type=script&lang=ts&external"
export * from "./Involvement.ts?vue&type=script&lang=ts&external"

import "./Involvement.scss?vue&type=style&index=0&id=f20ddb66&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f20ddb66"]])

export default __exports__